import InformationsData from "../../Data/InformationsData";

const Information = () => {
    return (
        <div className="flex flex-col gap-3 mt-4">
            {InformationsData.map((contact) => (
                <a
                    key={contact.key}
                    href={contact.Link}
                    rel="noreferrer"
                    target="_blank"
                    className="flex items-center gap-3 group"
                    style={{ textDecoration: "none" }}
                >
                    {/* Icon */}
                    <div
                        className="flex-shrink-0 flex items-center justify-center rounded-lg transition-colors duration-200"
                        style={{
                            width: "34px",
                            height: "34px",
                            background: "rgba(200,151,42,0.08)",
                            border: "1px solid rgba(200,151,42,0.18)",
                            color: "#C8972A",
                        }}
                    >
                        {contact.Icon}
                    </div>

                    {/* Text */}
                    <div className="overflow-hidden">
                        <p
                            className="text-gray-500"
                            style={{
                                fontSize: "9px",
                                letterSpacing: "0.18em",
                                textTransform: "uppercase",
                                fontWeight: 500,
                                marginBottom: "1px",
                            }}
                        >
                            {contact.Name}
                        </p>
                        <p
                            className="text-gray-300 group-hover:text-white transition-colors duration-150 truncate"
                            style={{ fontSize: "12px", fontWeight: 400 }}
                        >
                            {contact.Value}
                        </p>
                    </div>
                </a>
            ))}
        </div>
    );
};

export default Information;
